document.addEventListener("DOMContentLoaded", function () {
  var timer = document.querySelector(".countdown-timer");
  if (!timer) return;

  function getNextMidnight() {
    var now = new Date();
    var next = new Date(now);
    next.setDate(now.getDate() + 1);
    next.setHours(0, 0, 0, 0);
    return next;
  }

  function getTargetTime() {
    var endDate = timer.getAttribute("data-end-date");
    if (endDate && /^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
      var parts = endDate.split("-");
      var target = new Date(
        parseInt(parts[0]),
        parseInt(parts[1]) - 1,
        parseInt(parts[2]),
        0, 0, 0
      );
      if (!isNaN(target.getTime()) && target > new Date()) return target;
    }
    return getNextMidnight();
  }

  var targetTime = getTargetTime();

  function updateCountdown() {
    var now = new Date();

    if (now >= targetTime) {
      targetTime = getNextMidnight();
    }

    var difference = Math.floor((targetTime - now) / 1000);

    var days = Math.floor(difference / 86400);
    var hours = Math.floor((difference % 86400) / 3600);
    var minutes = Math.floor((difference % 3600) / 60);
    var seconds = difference % 60;

    var updateElement = function (id, value) {
      var elements = document.querySelectorAll("[data-id=" + id + "]");
      elements.forEach(function (el) {
        el.textContent = String(value).padStart(2, "0");
      });
    };

    updateElement("countdown-timer-days", days);
    updateElement("countdown-timer-hours", hours);
    updateElement("countdown-timer-minutes", minutes);
    updateElement("countdown-timer-seconds", seconds);

    setTimeout(updateCountdown, 1000);
  }

  updateCountdown();
});
